module.exports = __webpack_public_path__ + "static/media/img-content__people.e6729931.jpg";